import { app } from '~/helpers/firebase';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import type { User } from 'firebase/auth';

const auth = getAuth(app);

export function onAuthChange(cb: (user: User | null) => void) {
  onAuthStateChanged(auth, cb);
}

export function signIn(email: string, password: string) {
  return signInWithEmailAndPassword(auth, email, password);
}

export function logout() {
  auth.signOut();
}

export function getAuthToken() {
  const user = auth.currentUser;
  if (!user) throw new Error('No user');
  return user.getIdToken(true);
}